import { render } from "./CountdownObsView.vue?vue&type=template&id=08aee7ce&scoped=true"
import script from "./CountdownObsView.vue?vue&type=script&lang=js"
export * from "./CountdownObsView.vue?vue&type=script&lang=js"

import "./CountdownObsView.vue?vue&type=style&index=0&id=08aee7ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aee7ce"]])

export default __exports__